/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_DoneInputs */

const cs_jobs_status_done = /** @type {(inputs: Jobs_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotovo`)
};

const en_jobs_status_done = /** @type {(inputs: Jobs_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Jobs_Status_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_status_done = /** @type {((inputs?: Jobs_Status_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_status_done(inputs)
	return cs_jobs_status_done(inputs)
});